<template>
    <div class="info" v-if="baseInfo != null">
        <div class="row">
            <div class="col-12 col-lg-4">
                <span class="title">آدرس: </span> <span class="text-all">{{baseInfo.Address}}</span>
            </div>
            <div class="col-12 col-lg-2">
                <span class="title">شماره تماس: </span> <span class="text-all"> <a :href="'tel:' + baseInfo.TellNo ">{{ baseInfo.TellNo }}</a></span>
            </div>
            <div class="col-12 col-lg-3">
                <span class="title">ایمیل: </span><a :href="'mailto:' + baseInfo.Email ">{{ baseInfo.Email }}</a>
            </div>
            <div class="col-12 col-lg-3">
                <div class="socials">
                    <div class="footer-social">
                        <a :href="baseInfo.InstagramLink" :title="' اینستاگرام ' + baseInfo.ShopName" target="_blank"><i class="fa fa-instagram"></i> اینستاگرام</a>
                        <a :href="baseInfo.TelegramLink" class="margin" :title="' تلگرام ' + baseInfo.ShopName" target="_blank"><i class="fa fa-telegram"></i> تلگرام</a>
                        <a class="a-block" :href="baseInfo.AparatLink" :title="' آپارات ' + baseInfo.ShopName" target="_blank"><div class="div-image"><img class="img-aparat" src="/assets/img/aparat.png" /></div> آپارات</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        }
    }
</script>

<style scoped>
    .margin {
        margin:0 5px 0 5px;
    }
    .div-image {
        display: inline-block;
    }
    .text-all {
        font-size: 14px;
        font-weight: bold;
    }
</style>